export default __webpack_public_path__ + "static/media/reliance.46777eb7.jpg";